import Link from 'next/link'

import { Button } from '@wartek-id/button-v1'

import { CardNotificationBase } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'
import { PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH } from 'app/KinerjaShared/constants/path'
import { PENGELOLAAN_KINERJA_KS_PELAKSANAAN_STEPS } from 'app/KinerjaShared/constants/pelaksanaanSteps'

import type { PelaksanaanAppealableStep } from 'types/kinerja-ks-pelaksanaan'
import type { CardNotificationBaseProps } from 'app/KinerjaNotifikasiPage/components/CardNotification/CardNotificationBase'

type Props = CardNotificationBaseProps & {
  isApproved: boolean
  step: PelaksanaanAppealableStep
  requestorNpsn: string
}

export function CardNotificationKsPelaksanaanAppealKs({
  isApproved,
  step,
  requestorNpsn,
  ...cardProps
}: Props) {
  if (!isApproved) {
    return <CardNotificationBase {...cardProps} />
  }

  return (
    <CardNotificationBase {...cardProps}>
      <div className="mt-6">
        <Link
          href={`${
            PENGELOLAAN_KINERJA_KS_PELAKSANAAN_STEPS[step]?.path ??
            PENGELOLAAN_KINERJA_KS_PEGAWAI_PATH
          }?id=${requestorNpsn}`}
          passHref
        >
          <Button as="a" className="!inline-flex">
            Cek dokumen
          </Button>
        </Link>
      </div>
    </CardNotificationBase>
  )
}
